export const predefinedCategories = [
  { value: 'RENT', label: 'Rent', type: 'INCOME' },
  { value: 'MORTGAGE', label: 'Mortgage', type: 'EXPENSE' },
  { value: 'PROPERTY_TAX', label: 'Property Tax', type: 'EXPENSE' },
  { value: 'INSURANCE', label: 'Insurance', type: 'EXPENSE' },
  { value: 'MAINTENANCE', label: 'Maintenance', type: 'EXPENSE' },
  { value: 'UTILITIES', label: 'Utilities', type: 'EXPENSE' },
  { value: 'HOA', label: 'HOA Fees', type: 'EXPENSE' },
  { value: 'CAPEX', label: 'Capital Expenditures', type: 'EXPENSE' },
  { value: 'MANAGEMENT', label: 'Management Fees', type: 'EXPENSE' },
  { value: 'OTHER_INCOME', label: 'Other Income', type: 'INCOME' },
  { value: 'OTHER_EXPENSE', label: 'Other Expense', type: 'EXPENSE' },
] as const;

export type CategoryType = (typeof predefinedCategories)[number]['type'];
export type CategoryValue = (typeof predefinedCategories)[number]['value'];

export function getCategoryLabel(value: string): string {
  const category = predefinedCategories.find((cat) => cat.value === value);
  return category?.label || value;
}

export function getCategoryType(value: string): CategoryType {
  const category = predefinedCategories.find((cat) => cat.value === value);
  return category?.type || 'EXPENSE';
}
